(function () {
    "use strict";

    angular
        .module("app")
        .directive("consumerTerritorySearchHelp", ["SearchFactory", consumerTerritorySearchHelp]);

    function consumerTerritorySearchHelp(searchFactory) {
        return {
            restrict: "E",
            link: function (scope) {

                scope.search = function (forValidation) {
                    if (scope.readOnly === true) {
                        return;
                    }

                    if (forValidation && (!scope.displayValue || scope.displayValue.trim().length === 0)) {
                        scope.consumerTerritoryName = "";
                        scope.consumerTerritoryKey = "";
                        scope.prevDisplayValue = "";
                        scope.displayValue = "";
                        return;
                    }

                    scope.needToValidate = forValidation ? true : false;

                    if (forValidation && (scope.prevDisplayValue === scope.displayValue || scope.consumerTerritoryName === scope.displayValue)) {
                        scope.needToValidate = false;
                        return;
                    }

                    var modalSearch = searchFactory.consumerTerritorySearch(function (consumerTerritory) {
                        scope.consumerTerritoryKey = consumerTerritory ? consumerTerritory.CharacteristicValue : "";
                        scope.consumerTerritoryName = consumerTerritory ? consumerTerritory.CharacteristicDesc : "";
                        scope.displayValue = scope.consumerTerritoryName;

                        if (scope.prevDisplayValue !== scope.displayValue) {
                            scope.setDirtyCallback();
                        }

                        scope.prevDisplayValue = scope.displayValue;
                        scope.needToValidate = false;
                    });

                    modalSearch.startSearch(forValidation, ["", scope.displayValue]);
                };

                scope.$watch("consumerTerritoryName", function (newValue) {
                    scope.displayValue = newValue;
                });

                scope.displayValue = scope.consumerTerritoryName;
                scope.prevDisplayValue = scope.displayValue;

            },
            scope: { consumerTerritoryKey: "=", consumerTerritoryName: "=?", readOnly: "=", required: "=", controlName: "@", needToValidate: "=?", setDirtyCallback: "&" },
            templateUrl: templateUrl("app/directives/searchHelp/searchHelp.directive.html")
        };
    }
})();

